export default [
  require('./Leaderboard').default,
];
